import { CALL_API, Schemas } from '../../common/middleware/api';
import { reset } from 'redux-form';

export const INDIVIDUAL_CONSULTATIONS_REQUEST = 'INDIVIDUAL_CONSULTATIONS_REQUEST';
export const INDIVIDUAL_CONSULTATIONS_SUCCESS = 'INDIVIDUAL_CONSULTATIONS_SUCCESS';
export const INDIVIDUAL_CONSULTATIONS_FAILURE = 'INDIVIDUAL_CONSULTATIONS_FAILURE';

export const INDIVIDUAL_CONSULTATION_FETCH_REQUEST = 'INDIVIDUAL_CONSULTATION_GET_REQUEST';
export const INDIVIDUAL_CONSULTATION_FETCH_SUCCESS = 'INDIVIDUAL_CONSULTATION_GET_SUCCESS';
export const INDIVIDUAL_CONSULTATION_FETCH_FAILURE = 'INDIVIDUAL_CONSULTATION_GET_FAILURE';

export const INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_REQUEST = 'INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_FAILURE = 'INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_FORM_UPDATE_REQUEST = 'INDIVIDUAL_CONSULTATION_FORM_UPDATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_FORM_UPDATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_FORM_UPDATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_FORM_UPDATE_FAILURE = 'INDIVIDUAL_CONSULTATION_FORM_UPDATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_DOCUMENTS_REQUEST = 'INDIVIDUAL_CONSULTATION_DOCUMENTS_REQUEST';
export const INDIVIDUAL_CONSULTATION_DOCUMENTS_SUCCESS = 'INDIVIDUAL_CONSULTATION_DOCUMENTS_SUCCESS';
export const INDIVIDUAL_CONSULTATION_DOCUMENTS_FAILURE = 'INDIVIDUAL_CONSULTATION_DOCUMENTS_FAILURE';

export const INDIVIDUAL_CONSULTATION_DASHBOARD_REQUEST = 'INDIVIDUAL_CONSULTATION_DASHBOARD_REQUEST';
export const INDIVIDUAL_CONSULTATION_DASHBOARD_SUCCESS = 'INDIVIDUAL_CONSULTATION_DASHBOARD_SUCCESS';
export const INDIVIDUAL_CONSULTATION_DASHBOARD_FAILURE = 'INDIVIDUAL_CONSULTATION_DASHBOARD_FAILURE';

export const loadIndividualConsultations = (options) => ({
    [CALL_API]: {
        types: [INDIVIDUAL_CONSULTATIONS_REQUEST, INDIVIDUAL_CONSULTATIONS_SUCCESS, INDIVIDUAL_CONSULTATIONS_FAILURE],
        endpoint: 'api/individualConsultations',
        request: options,
        schema: Schemas.INDIVIDUAL_CONSULTATION_ARRAY
    }
});

export const fetchIndividualConsultation = (id, forceReload) => (dispatch, getState) => {
    if (!forceReload && getState().entities.individualConsultations[id]) {
        return null;
    }

    dispatch({
        [CALL_API]: {
            types: [INDIVIDUAL_CONSULTATION_FETCH_REQUEST, INDIVIDUAL_CONSULTATION_FETCH_SUCCESS, INDIVIDUAL_CONSULTATION_FETCH_FAILURE],
            endpoint: `api/individualConsultations/${id}`,
            schema: Schemas.INDIVIDUAL_CONSULTATION
        }
    });
};

export const createIndividualConsultationDocument = (id, document) => dispatch => {
    dispatch({
        [CALL_API]: {
            types: [INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_REQUEST, INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_SUCCESS, INDIVIDUAL_CONSULTATION_DOCUMENT_CREATE_FAILURE],
            endpoint: `api/individualConsultations/${id}/documents`,
            method: 'POST',
            request: document,
            schema: Schemas.INDIVIDUAL_CONSULTATION,
            form: 'documentForm',
            onSuccess: () => dispatch(reset('documentForm'))
        }
    });
};

export const updateIndividualConsultationForm = (consultationId, formId, form, onSuccess, onError) => ({
    [CALL_API]: {
        types: [INDIVIDUAL_CONSULTATION_FORM_UPDATE_REQUEST, INDIVIDUAL_CONSULTATION_FORM_UPDATE_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_UPDATE_FAILURE],
        endpoint: `api/individualConsultations/${consultationId}/forms/${formId}`,
        method: 'PUT',
        request: form,
        schema: Schemas.INDIVIDUAL_CONSULTATION,
        form: 'customForm',
        onSuccess,
        onError
    }
});

export const loadIndividualConsultationDocuments = ({ childId, type, ...options }) => ({
    [CALL_API]: {
        types: [INDIVIDUAL_CONSULTATION_DOCUMENTS_REQUEST, INDIVIDUAL_CONSULTATION_DOCUMENTS_SUCCESS, INDIVIDUAL_CONSULTATION_DOCUMENTS_FAILURE],
        endpoint: 'api/individualConsultationDocuments',
        request: { childId, type, ...options },
        schema: Schemas.INDIVIDUAL_CONSULTATION_DOCUMENT_ARRAY
    },
    childId,
    documentType: type
});


export const loadChildConsultationsForDashboard = () => ({
    [CALL_API]: {
        types: [INDIVIDUAL_CONSULTATION_DASHBOARD_REQUEST, INDIVIDUAL_CONSULTATION_DASHBOARD_SUCCESS, INDIVIDUAL_CONSULTATION_DASHBOARD_FAILURE],
        endpoint: `api/individualConsultations/dashboard`,
        schema: Schemas.INDIVIDUAL_CONSULTATION_DASHBOARD_ARRAY
    }
});
